import { useEffect, useState } from "react";
import { Dialog, DialogContent } from "./ui/dialog";
import { Search } from "lucide-react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";

export default function SearchDialog({ open, onOpenChange }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!q.trim()) { setResults([]); return; }
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/search`, { params: { q } });
        setResults(data.results || []);
      } finally { setLoading(false); }
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  useEffect(() => { if (open) setQ(""); }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-surface border-line p-0" data-testid="search-dialog">
        <div className="flex items-center gap-3 border-b border-line px-5 py-4">
          <Search size={18} strokeWidth={1.7} className="text-muted"/>
          <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="Search articles, destinations, places…" className="flex-1 bg-transparent outline-none text-base placeholder:text-muted" data-testid="search-input"/>
          <span className="kbd">esc</span>
        </div>
        <div className="max-h-[60vh] overflow-y-auto">
          {loading && <div className="p-8 text-muted text-sm">Searching…</div>}
          {!loading && q && results.length === 0 && (
            <div className="p-8 text-muted text-sm" data-testid="search-empty">No results for "{q}".</div>
          )}
          {!loading && results.map(r => (
            <Link key={r.slug} to={`/articles/${r.slug}`} onClick={() => onOpenChange(false)} className="flex gap-4 px-5 py-4 border-b border-line hover:bg-alt transition-colors" data-testid={`search-result-${r.slug}`}>
              <img src={r.cover} alt="" className="w-20 h-14 object-cover"/>
              <div className="flex-1 min-w-0">
                <div className="overline mb-1 text-olive">{r.destination}</div>
                <div className="font-serif text-xl leading-tight">{r.title}</div>
                <div className="text-sm text-muted truncate mt-1">{r.snippet}</div>
              </div>
            </Link>
          ))}
          {!loading && !q && (
            <div className="p-8 text-muted text-sm">Try: <span className="text-ink">Selfridges</span>, <span className="text-ink">pandas</span>, <span className="text-ink">Saadiyat</span>, <span className="text-ink">desert</span></div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
